import React, { useState } from "react";
import { Row, Col, Card, CardBody, Button, Popover, PopoverHeader, PopoverBody, UncontrolledPopover, } from "reactstrap";
import Steps from "../../Generales/Steps";
import Page from "../../Page";
import styles from "./styles";
import { Checkbox } from "react-inputs-validation";
import Formulario from "../../Generales/Formulario";


const ContainerIndividual = (props) => {

    const [popoverOpen, setPopoverOpen] = React.useState(false);
    const [popover, setPopover] = useState(
        {
            titulo: '',
            descripcion: ''
        }
    )

    const [datosCotizador, setDatosCotizador] = useState(
        {
            nombreCotizador: 'Seguro de Vehículos - Comparador',
            paso: 'cotizacion'
        }
    )

    const [datosVehiculo, setDatosVehiculo] = useState(
        [
            {
                titulo: 'Marca',
                valor: 'Hyundai',
                codigo: 'marca',
            },
            {
                titulo: 'Chasis',
                valor: 'KMHLJ2813AJU699190',
                codigo: 'marca',
            },
            {
                titulo: 'Placa',
                valor: 'PDF1056',
                codigo: 'marca',
            },
            {
                titulo: 'Modelo',
                valor: 'ACCENT 16L 4P GL',
                codigo: 'marca',
            },
            {
                titulo: 'Clase',
                valor: 'SEDAN',
                codigo: 'marca',
            },
            {
                titulo: 'Año',
                valor: '2018',
                codigo: 'marca',
            },
            {
                titulo: 'Motor',
                valor: 'J4NAJU5923456',
                codigo: 'marca',
            },
            {
                titulo: 'Uso',
                valor: 'Personal',
                codigo: 'marca',
            },
        ]
    )

    const [values, setValues] = useState({})
    const [values2, setValues2] = useState({})

    const [preguntas, setPreguntas] = useState(
        [
            {
                titulo: '¿El vehículo posee rastreo satelital?',
                valor: true
            },
            {
                titulo: '¿El vehículo posee accesorios adicionales?',
                valor: false
            }
        ]
    )

    const [planes, setPlanes] = useState(
        [
            {
                titulo: 'RESPONSABILIDAD CIVIL',
                color: '#ffbf3f',
                visible: true,
                primaTotal: '$386,40',
                coberturasAdicionales: [
                    {
                        titulo: 'Amparo Patrimonial',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Cobertura con costo adicional',
                            subTitulo: null
                        },
                        aplica: true,
                        check: false
                    },
                    {
                        titulo: 'Objetos Olvidados dentro del vehículo',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Cobertura con costo adicional',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        aplica: false,
                        check: false
                    }, {
                        titulo: 'Gastos funerarios',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Cobertura con costo adicional',
                            subTitulo: null
                        },
                        aplica: false,
                        check: false
                    }
                ],
                coberturas: [
                    {
                        titulo: 'Responsabilidad civil',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Pérdica parcial del vehículo por daños',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Perdida total del vehículo por robo',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Asistencia jurídica en proceso penal',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Metroassit',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Robo parcial accesorios extras',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Auto sustituto',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: false
                    },
                    {
                        titulo: 'Llave protegida',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: false
                    },
                    {
                        titulo: 'Documentos protegidos',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: false
                    },
                    {
                        titulo: 'Accidentes personales por accidente',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: false
                    },
                ],


            },
            {
                titulo: 'RESPONSABILIDAD CIVIL + PERDIDA TOTAL',
                color: '#bc95e8',
                visible: true,
                primaTotal: '$689,67',
                coberturas: [
                    {
                        titulo: 'Responsabilidad civil',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Pérdica parcial del vehículo por daños',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Perdida total del vehículo por robo',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Asistencia jurídica en proceso penal',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Metroassit',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Robo parcial accesorios extras',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Auto sustituto',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Llave protegida',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Documentos protegidos',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: false
                    },
                    {
                        titulo: 'Accidentes personales por accidente',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: false
                    },
                ],
                coberturasAdicionales: [
                    {
                        titulo: 'Amparo Patrimonial',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Cobertura con costo adicional',
                            subTitulo: null
                        },
                        aplica: true,
                        check: false
                    },
                    {
                        titulo: 'Objetos Olvidados dentro del vehículo',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Cobertura con costo adicional',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        aplica: true,
                        check: false
                    }, {
                        titulo: 'Gastos funerarios',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Cobertura con costo adicional',
                            subTitulo: null
                        },
                        aplica: true,
                        check: false
                    }
                ],
            },
            {
                titulo: 'FULL COBERTURA',
                color: '#c0e7f7',
                visible: true,
                primaTotal: '$1345,56',
                coberturasAdicionales: [
                    {
                        titulo: 'Amparo Patrimonial',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Cobertura con costo adicional',
                            subTitulo: null
                        },
                        aplica: true,
                        check: false
                    },
                    {
                        titulo: 'Objetos Olvidados dentro del vehículo',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Cobertura con costo adicional',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        aplica: true,
                        check: false
                    }, {
                        titulo: 'Gastos funerarios',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Cobertura con costo adicional',
                            subTitulo: null
                        },
                        aplica: true,
                        check: false
                    }
                ],
                coberturas: [
                    {
                        titulo: 'Responsabilidad civil',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Pérdica parcial del vehículo por daños',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Perdida total del vehículo por robo',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Asistencia jurídica en proceso penal',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Metroassit',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Robo parcial accesorios extras',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Auto sustituto',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Llave protegida',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Documentos protegidos',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                    {
                        titulo: 'Accidentes personales por accidente',
                        descripcion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                        limite: {
                            titulo: 'Valor asegurado',
                            subTitulo: '(se completa con el valor escogido)'
                        },
                        check: true
                    },
                ]
            }
        ]
    )

    const [planSeleccionado, setPlanSeleccionado] = useState(
        planes[0]
    )

    return (

        <main class="cr-app bg-light">
            <div class="cr-content container-fluid">
                <div className="container-body-spaces">


                    <Page
                        title={datosCotizador.nombreCotizador}
                        breadcrumbs={[{ name: datosCotizador.nombreCotizador, active: true }]}
                    >
                        <Row>
                            <Col lg={8} md={12} sm={12} xs={12}>
                                <Steps tipo={'apAbierto'} paso={datosCotizador.paso}></Steps>

                            </Col>
                        </Row>

                        <Row>
                            <Col lg={8} md={12} sm={12} xs={12}>
                                <Card>
                                    <CardBody>
                                        <span style={styles.datosDelVehCulo}>
                                            Datos del Vehículo
                                        </span>

                                        <div style={styles.cardDatosVehiculo}>

                                            <Row>
                                                {datosVehiculo.map(vehiculo => {
                                                    return (
                                                        <Col md={4}>
                                                            <Row>
                                                                <Col md={4}>
                                                                    <span style={styles.tituloVehiculo}>
                                                                        {vehiculo.titulo}:
                                                                    </span>
                                                                </Col>
                                                                <Col md={8}>

                                                                    <span style={styles.subTituloVehiculo}>
                                                                        {vehiculo.valor}
                                                                    </span>

                                                                </Col>
                                                            </Row>
                                                        </Col>

                                                    )
                                                })}

                                            </Row>

                                        </div>

                                        <div style={styles.divPreguntas}>

                                            {preguntas.map(pregunta => {
                                                return (
                                                    <Row>
                                                        <Col md={6}>
                                                            <span style={styles.pregunta}>
                                                                {pregunta.titulo}
                                                            </span>
                                                        </Col>
                                                        <Col md={6}>
                                                            <Checkbox
                                                                id={pregunta.titulo} // Optional.[String].Default: "".  Input ID.
                                                                name={pregunta.titulo} // Optional.[String].Default: "". Input name
                                                                value={pregunta.valor} // Required.[String].Default: "".
                                                                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                                checked={pregunta.valor} // Required.[Bool].Default: false.
                                                                classNameInputBox={'check-uber'}
                                                                onChange={(utilizarMismaTarjeta, e) => {


                                                                }} // Required.[Func].Default: () => {}. Will return the value.
                                                                validationOption={{
                                                                    name: "agreement", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                                                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )
                                            })}

                                        </div>


                                    </CardBody>
                                </Card>

                                <Formulario
                                    codigoFormulario={'formulario-datos-cliente-2'}
                                    onSubmit={(valores, tieneErrores, errores) => {
                                    }}
                                    values={values}
                                    setLoading={() => false}
                                    onChange={(key, values) => {
                                        setValues(values)
                                    }}
                                    setValuesInicial={(values) => {
                                        setValues(values)
                                    }}
                                />


                                <Formulario
                                    codigoFormulario={'formulario-datos-cliente'}
                                    onSubmit={(valores, tieneErrores, errores) => {
                                    }}
                                    values={values}
                                    setLoading={() => false}
                                    onChange={(key, values) => {
                                        setValues(values)
                                    }}
                                    setValuesInicial={(values) => {
                                        setValues(values)
                                    }}
                                />

                                <Card>
                                    <CardBody>
                                        <span style={styles.datosDelVehCulo}>
                                            Coberturas
                                        </span>

                                        <div style={styles.divPreguntas}>
                                            <div style={styles.divCoberturas}>
                                                <div style={styles.divTitulo}>
                                                    <div style={styles.divEncabezado}>
                                                        <span style={styles.tituloEncabezado}>
                                                            Coberturas
                                                        </span>

                                                    </div>
                                                    <div style={{ ...styles.divCategoriaPrecio }}>
                                                        <span style={styles.tituloCoberturasPrecio}>

                                                        </span>
                                                    </div>
                                                    {planSeleccionado.coberturas.map((cobertura, index) => {
                                                        return (
                                                            <div style={{ ...styles.divCategoriaPrecio2 }}>

                                                                <span style={styles.tituloCategoria2} onClick={() => setPopover({ titulo: cobertura.titulo, descripcion: cobertura.descripcion })}>
                                                                    <div id={"Popover1"} style={styles.elipse}>
                                                                        <i style={styles.elipseText}
                                                                            className='fa fa-question'
                                                                            aria-hidden='true'
                                                                        />
                                                                    </div>




                                                                    {cobertura.titulo}
                                                                </span>

                                                            </div>
                                                        )
                                                    })}
                                                </div>


                                                {planes.filter(plan => plan.visible === true).map(plan => {
                                                    return (
                                                        <div style={styles.divContainerCategoriaSeleccionada}>
                                                            <div style={plan.titulo === planSeleccionado.titulo ? styles.divCategoriaSeleccionada : styles.divCategoria}>
                                                                <div style={{ ...styles.divCategoriaTitulo, backgroundColor: plan.color }}>
                                                                    <span style={styles.tituloCoberturasMain}>
                                                                        {plan.titulo}
                                                                    </span>
                                                                </div>

                                                                <div style={{ ...styles.divCategoriaPrecio }}>
                                                                    <span style={styles.tituloCoberturasPrecio}>
                                                                        {plan.primaTotal}
                                                                    </span>
                                                                </div>
                                                                {plan.coberturas.map(cobertura => {
                                                                    return (
                                                                        <div style={{ ...styles.divCategoriaPrecio }}>
                                                                            {cobertura.check ?
                                                                                <div style={styles.divCheck}>
                                                                                    <i style={styles.check}
                                                                                        className='fa fa-check'
                                                                                        aria-hidden='true'

                                                                                    />

                                                                                </div>
                                                                                : <div style={styles.divCheckOut}>
                                                                                    <i style={styles.check}
                                                                                        className='fa fa-minus'
                                                                                        aria-hidden='true'
                                                                                    />

                                                                                </div>
                                                                            }

                                                                        </div>
                                                                    )
                                                                })}

                                                                <div style={{ ...styles.divCategoriaPrecio }}>



                                                                </div>
                                                            </div>

                                                            <div style={{ ...styles.divCategoriaPrecio }}>
                                                                {/*   <Button style={{ width: '200px' }} onClick={() => setPlanSeleccionado(plan)}>
                                                                        Seleccionar
                                                                    </Button> */}

                                                                <div
                                                                    style={planSeleccionado.titulo == plan.titulo ? styles.botonActivo : styles.botonInactivo}
                                                                    onClick={() => setPlanSeleccionado(plan)}
                                                                >
                                                                    <span
                                                                        style={planSeleccionado.titulo == plan.titulo ? styles.textoBotonActivo : styles.textoBotonInactivo}
                                                                        onClick={() => setPlanSeleccionado(plan)}
                                                                    >
                                                                        Elijo esta opción

                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )
                                                })}





                                            </div>



                                        </div>

                                        {planSeleccionado.coberturasAdicionales &&
                                            <div style={styles.divPreguntas2}>
                                                <div style={styles.divCoberturas}>
                                                    <div style={styles.divTitulo3}>
                                                        <div style={styles.divEncabezado2}>
                                                            <span style={styles.tituloEncabezado2}>
                                                                Coberturas adicionales
                                                            </span>

                                                        </div>
                                                        <div style={{ ...styles.divCategoriaPrecio }}>
                                                            <span style={styles.tituloCoberturasPrecio}>

                                                            </span>
                                                        </div>
                                                        {planSeleccionado.coberturasAdicionales.map(cobertura => {
                                                            return (
                                                                <div style={{ ...styles.divCategoriaPrecio2 }}>

                                                                    <span style={styles.tituloCategoria2} onClick={() => setPopover({ titulo: cobertura.titulo, descripcion: cobertura.descripcion })}>
                                                                        <div id={"Popover1"} style={styles.elipse}>
                                                                            <i style={styles.elipseText}
                                                                                className='fa fa-question'
                                                                                aria-hidden='true'
                                                                            />
                                                                        </div>




                                                                        {cobertura.titulo}
                                                                    </span>

                                                                </div>
                                                            )
                                                        })}
                                                    </div>

                                                    <div style={styles.divTitulo2}>
                                                        <div style={styles.divEncabezado3}>


                                                        </div>
                                                        <div style={{ ...styles.divCategoriaPrecio3 }}>

                                                        </div>
                                                        {planSeleccionado.coberturasAdicionales.map(cobertura => {
                                                            return (

                                                                cobertura.aplica ?
                                                                    <div style={{ ...styles.divCategoriaPrecio5 }}>
                                                                        <div style={styles.divBotonAgregar}>
                                                                            <span style={styles.textoBotonAgregar}>
                                                                                Agregar
                                                                            </span>
                                                                        </div>


                                                                    </div>
                                                                    :
                                                                    <div style={{ ...styles.divCategoriaPrecio5 }}>
                                                                        <span style={styles.tituloCoberturasNoAplica}>
                                                                           No aplica
                                                                        </span>


                                                                    </div>
                                                            )
                                                        })}
                                                    </div>







                                                </div>

                                                <UncontrolledPopover
                                                    placement="bottom" isOpen={popoverOpen}
                                                    target={"Popover1"}
                                                    trigger="legacy"
                                                    toggle=
                                                    {() => { setPopoverOpen(!popoverOpen) }}>
                                                    <PopoverHeader
                                                        style={styles.popHeader}>{popover.titulo}</PopoverHeader>
                                                    <PopoverBody>{popover.descripcion}</PopoverBody>
                                                </UncontrolledPopover>

                                            </div>
                                        }






                                    </CardBody>

                                </Card>


                            </Col>
                        </Row>



                    </Page>
                </div>
            </div>
        </main>
    );
};
export default ContainerIndividual;
